<template>
  <div class="contaier" v-loading="loading">
     <div class="title" style="padding-top: 20px;display: flex;align-items: center;width: 100%;justify-content: center;">您的专属MBTI职业性格测试报告已生成
      <el-button type="primary" @click="backHome" style="margin-left: 30px;">返回首页</el-button>
     </div>
     <div class="banner-time">生成于：{{info.create_time}}</div>
     <div class="main">
         <div class="base-fx pre-wrap">
           <div class="titles">{{info.TITLE}}</div>
           <div class="left-head">#你的测试类型#</div>
           <div class="left-body">{{info.iden}}</div>
         </div>
     </div>
     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title">个性特征</div>
          <div class="jianjie">
            {{info.gexing}}
          </div>
       </div>
     </div>
     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 155px;">可能存在的盲点</div>
          <div class="jianjie">
            {{info.mangdian}}
          </div>
       </div>
     </div>
     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title">功能运用</div>
          <div class="jianjie">
            {{info.gongneng}}
          </div>
       </div>
     </div>
     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 200px;">有效地使用你的类型</div>
          <div class="jianjie">
           {{info.youxiao}}
          </div>
       </div>
     </div>
     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 135px;">问题解决方式</div>
          <div class="jianjie">
            {{info.jiejue}}
          </div>
       </div>
     </div>
     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title"  style="width: 135px;">工作中的优势</div>
          <div class="jianjie">
            {{info.youshi}}
          </div>
       </div>
     </div>
     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 135px;">工作中的劣势</div>
          <div class="jianjie">
            {{info.lueshi}}
          </div>
       </div>
     </div>
     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 154px;">适合的岗位特质</div>
          <div class="jianjie">
            {{info.tezhi}}
          </div>
       </div>
     </div>
     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 265px;">职业类型——您适合的职业</div>
          <div class="jianjie">
            {{info.zhiyetype}}
          </div>
       </div>
     </div>
     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 135px;">对组织的贡献</div>
          <div class="jianjie">
            {{info.gongxian}}
          </div>
       </div>
     </div>
     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title">领导风格</div>
          <div class="jianjie">
            {{info.lingdao}}
          </div>
       </div>
     </div>
     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title">潜在缺陷</div>
          <div class="jianjie">
            {{info.qianzai}}
          </div>
       </div>
     </div>
     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 155px;">适合的工作环境</div>
          <div class="jianjie">
            {{info.shihe}}
          </div>
       </div>
     </div>
     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 135px;">个人发展建议</div>
          <div class="jianjie">
            {{
              info.fazhan
            }}
          </div>
       </div>
     </div>
  </div>
</template>

<script>
  import { lookDetailCengping } from "@/api/gw/ceping"
  import {
    mapGetters
  } from "vuex"
  export default {
    computed: {
      ...mapGetters(['isLogin', "userinfo"]),
    },
    data(){
      return{
          loading:false,
          info:{}
      }
    },
    mounted(){
      console.log("login13")
      this.$store.dispatch("getUserInfo").then(res=>{
        if(res.role==1){
          this.$confirm('此测评为VIP专属功能，开通VIP才可以使用?', '提示', {
            confirmButtonText: '购买VIP',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({
              path: "/Home",
              query: {
                type: 3
              }
            })
          })
        }else{
            this.lookDetailCengping();
        }
      })
    },
    methods:{
      backHome(){
        this.$router.push({
          path:"/"
        })
      },
        lookDetailCengping(){
          this.loading = true
          lookDetailCengping({}).then(res=>{
            this.info = res.data || {}
          }).finally(()=>{
            this.loading = false
          })
        }
    },
  }
</script>

<style lang="scss" scoped>
  .base-quota-title{
    color: rgb(51, 58, 80);
    font-size: 22px;
    font-weight: bold;
    position: relative;
    width: 92px;
    line-height: 0.5;
    border-bottom: 10px solid rgb(211, 223, 244);
  }
  .jianjie{
    color: #515151;
    font-size: 16px;
    line-height: 32px;
        margin-top: 20px;
        text-indent: 2em;
  }
.main{
  display: flex;
  align-items: center;
  margin: 0 auto;
  .base-fx{
    position: relative;
    box-shadow: 0 0.075rem 0.725rem 0.025rem rgba(183,186,207,.18);
    border-radius: 10px 10px 40px 10px;
    background-color: #fdfdff;
    border-bottom-right-radius: 40px;
    padding-top: 20px;
    padding-bottom: 20px;
    width: 720px;
    margin: 0 auto;
    margin-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    .left-head{
      font-size: 14px;
      color: #6a6f92;
      margin-top: 20px;
    }
    .left-body{
      width: 100%;
      text-align: center;
      color:#f25754;
      font-size: 70px;
      font-weight: bold;
      margin-top:20px;
    }
    .titles{

    }
  }
}
@import './scss/info.scss';
.banner-time{
  color: #fff;
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/appraisal/mbtiResult.vue